<!-- 轮廓界面 -->
<template>
  <div class="app-container">
    <DownloadApp v-if="isShowDownload && isHomePage" @close="isShowDownload = false" />
    <div
      :class="`layout-content ${THEME}_CONT ` + (showFooter || $route.meta.hasFooter ? 'hasFooter' : '') + (isShowDownload && route.name === 'Home' ? ' layout-top' : '')">
      <router-view v-slot="{ Component }" class="min-height">
        <transition name="van-fade" class="min-height">
          <keep-alive v-if="$route.meta.keepAlive">
            <component :is="Component" />
          </keep-alive>
          <component v-else :is="Component" />
        </transition>
      </router-view>
    </div>
    <div v-if="showFooter || $route.meta.hasFooter" class="layout-footer" :class="`layout-footer-${THEME}`">
      <template v-if="isAgentFooter">
        <TabBar class="agent-tabbar" :data="agentTabBar" @chang="handleChange" @beforeChange="beforeChange"></TabBar>
      </template>
      <TabBar v-else :data="tabBar" @chang="handleChange" @beforeChange="beforeChange"></TabBar>
    </div>
    <IosAddHome v-if="showAddHomePopover && isHomePage" @close="showAddHomePopover = false" />
    <!-- <RedPack v-if="isHomePage && activeConfiguration['15']" /> -->

    <!-- <KefuLayOut v-if="(!isIframe) && activeConfiguration['68']" /> -->
    <!-- <GameKJW v-if="isGamePage && opening_network" /> -->
    <van-popup v-model:show="showTryLogin" class="pop-code-wrap" round teleport="body"
      :style="{ height: '100%', width: '100%' }">
      <TryLogin />
    </van-popup>

  </div>
</template>

<script lang="ts">
import { reactive, toRefs, computed, watch, onMounted, onBeforeMount, ref } from 'vue';
import { mb_err, mb_t } from '/@/plugins/global';
import { useRoute } from 'vue-router';
import { useHot } from '/@/kernel-mn/stores/useHot';
import { useUserStore } from '/@/kernel-mn/stores/user';
import { useGameStore } from '/@/kernel-mn/stores/game';
import { HIDE_THE_BOTTOM_PAGE } from '/@/config';
import KefuLayOut from "./child-page/KefuLayOut.vue";
import RedPack from "/@/layout/child-page/RedPack.vue";
import TabBar from "/@/layout/child-page/TabBar.vue";
import GameKJW from "/@/layout/child-page/GameKJW.vue";
import { useTenantStore } from '/@/kernel-mn/stores/tenant';
import { isApp, isIOS, isSafari } from '/@/kernel-mn/utils';
import { setSession } from "/@/kernel-mn/utils/storage";
import IosAddHome from './child-page/IosAddHome.vue';
import DownloadApp from './child-page/DownloadApp.vue';
import TryLogin from './child-page/TryLogin.vue';
import { KEY_FBREQTIME, KEY_FBSPORT } from '/@/config/const'
import dayjs from 'dayjs';

export default {
  components: { GameKJW, TabBar, RedPack, KefuLayOut, IosAddHome, DownloadApp, TryLogin },
  setup() {
    const userStore = useUserStore()
    const gameStore = useGameStore();
    const { hotData: { userInfo, isLogined, tenantInfo }, activeConfiguration, tResLoc } = useHot();
    const showAddHomePopover = ref(false)
    const isShowDownload = ref(false)
    const route = useRoute();
    const tenantState = useTenantStore();
    const showFooter = computed(() => {
      let flag = true;
      // @ts-ignore
      let name = route.name + '';
      if (HIDE_THE_BOTTOM_PAGE.includes(name)) {
        flag = false;
      }
      // console.log(route.name, 'showFooter:', HIDE_THE_BOTTOM_PAGE, flag)
      return flag;
    });
    // 代理中心底部
    const isAgentFooter = computed(() => {
      let flag = false, name: any = route.name;
      if (['AgHome', 'AgFinance', 'AgMy', 'AgNotice', 'AgShare', 'AgGameList', 'AgYouhui', 'AgFeeReport', 'AgEscrowRecord', 'AgPingtaiReport', 'AgTichengRecord', 'AgUserReport'].includes(name)) flag = true;
      return flag;
    });

    const getNewFbStatus = () => {
      const { GamesPlatform } = gameStore
      // console.log(GamesPlatform, 'getNewFbStatus==>gameStore.GamesPlatform:', GamesPlatform.data)
      if (GamesPlatform && GamesPlatform.data) {
        const thirdGames = GamesPlatform.data.thirdGames || []
        const newFb = thirdGames.find(o => o.play_id == 1310)
        if (newFb) {
          return [1, 4].includes(+newFb.state)
        }
      }
      return false
    }

    //底部tab栏相关
    const getTab = () => {
      const fbStatus = getNewFbStatus()
      const theme = tResLoc.value;
      const tab: any = [
        {
          title: mb_t('首页'),
          name: 'home',
          to: { name: 'Home' },
          icon: `/images/${theme}/tabbar/home.png`,
          iconActive: `/images/${theme}/tabbar/home_active.png`,
        },
        {
          title: mb_t('充值'),
          name: 'recharge',
          to: { name: isLogined.value ? 'Recharge' : 'Login' },
          icon: `/images/${theme}/tabbar/recharge.png`,
          iconActive: `/images/${theme}/tabbar/recharge_active.png`,
        },
        {
          title: mb_t('游戏'),
          name: 'game',
          to: { name: 'Game' },
          icon: `/images/${theme}/tabbar/game.png`,
          iconActive: `/images/${theme}/tabbar/game_active.png`,
        },

        {
          title: mb_t('优惠'),
          name: 'task',
          to: { name: 'Task' },
          icon: `/images/${theme}/tabbar/activity.png`,
          iconActive: `/images/${theme}/tabbar/activity_active.png`,
        },
        {
          title: mb_t('我的'),
          name: 'mine',
          to: { name: 'Mine' },
          icon: `/images/${theme}/tabbar/my.png`,
          iconActive: `/images/${theme}/tabbar/my_active.png`
        }
      ];
      const sportTab = [
        {
          title: mb_t('首页'),
          name: 'home',
          to: { name: 'Home' },
          icon: `/images/${theme}/tabbar/home.png`,
          iconActive: `/images/${theme}/tabbar/home_active.png`,
        },

        {
          title: mb_t('游戏'),
          name: 'game',
          to: { name: 'Game' },
          icon: `/images/${theme}/tabbar/game.png`,
          iconActive: `/images/${theme}/tabbar/game_active.png`,
        },
        {
          title: mb_t('体育'),
          name: 'sport',
          to: { name: 'Sport' },
          icon: `/images/${theme}/tabbar/sport.png`,
          iconActive: `/images/${theme}/tabbar/sport_active.png`,
        },
        {
          title: mb_t('优惠'),
          name: 'task',
          to: { name: 'Task' },
          icon: `/images/${theme}/tabbar/activity.png`,
          iconActive: `/images/${theme}/tabbar/activity_active.png`,
        },
        {
          title: mb_t('我的'),
          name: 'mine',
          to: { name: 'Mine' },
          icon: `/images/${theme}/tabbar/my.png`,
          iconActive: `/images/${theme}/tabbar/my_active.png`
        }
      ]
      // const showTab = tab.filter(t=>{
      //   if(t.name === 'sport'){
      //     return fbStatus
      //   }else if(t.name === 'recharge'){
      //     return !fbStatus
      //   }
      //   return true
      // });
      return fbStatus ? sportTab : tab
    };
    // 代理中心tab
    const getAgentTab = () => {
      let basepath = `/images/agent/${tResLoc.value}/tabbar`;
      let agenttab = [
        {
          title: mb_t('首页'),
          to: { name: 'AgHome' },
          issvg: false,
          icon: `${basepath}/ag_home.png`,
          iconActive: `${basepath}/ag_home_active.png`
        },
        {
          title: mb_t('我的'),
          to: { name: 'AgMy' },
          icon: `${basepath}/ag_my.png`,
          iconActive: `${basepath}/ag_my_active.png`,
        },
        {
          title: mb_t('财务'),
          to: { name: 'AgFinance' },
          icon: `${basepath}/ag_caiwu.png`,
          iconActive: `${basepath}/ag_caiwu_active.png`,
        },
        {
          title: mb_t('推广'),
          to: { name: 'AgShare' },
          icon: `${basepath}/ag_tuiguang.png`,
          iconActive: `${basepath}/ag_tuiguang_active.png`,
        },
        {
          title: mb_t('公告'),
          to: { name: 'AgNotice' },
          icon: `${basepath}/ag_notice.png`,
          iconActive: `${basepath}/ag_notice_active.png`,
        },
      ];
      return agenttab;
    };
    const useTabBar = () => {
      const state = reactive({
        tabBar: getTab(),
        agentTabBar: getAgentTab()
      });
      return toRefs(state);
    };
    const { tabBar, agentTabBar }: any = useTabBar();
    watch(userInfo, nv => {
      if (nv && nv.cust_id) {
        agentTabBar.value = getAgentTab();
        tabBar.value = getTab();
      }
    }, { immediate: true });
    watch(activeConfiguration, () => {
      tabBar.value = getTab();
    }, { deep: true });

    // eslint-disable-next-line no-unused-vars
    const handleChange = value => {
      // console.log('handleChange:handleChange:',value)
      setSession('__markPay__', ``)
    };
    // 跳转之前
    const beforeChange = item => {
      // console.log('beforeChange',item)
      // 按钮关闭 点击 提示的文字
      if (item.closedTxt) {
        mb_err(item.closedTxt, 2);
      }
    };
    const showTryLogin = computed(() => {
      const isShow = userStore.tryLoinInfo.show
      // console.log('tryLoinInfo',userStore.tryLoinInfo)
      return !!isShow
    })
    const isHomePage = computed(() => {
      return route.name === 'Home';
    });
    const isIframe = computed(() => {
      return route.name === 'iframe' || route.name === 'Login';
    });
    // 游戏投注页面
    const isGamePage = computed(() => {
      return ['Pk10', 'Hklottery', 'Cqlhc', 'K3', 'Qkl', 'Ydc', 'Xnb', 'animal'].includes(<string>route.name)
    });
    // 开奖网地址
    const opening_network = computed(() => (tenantInfo.value?.tenant?.opening_network ?? ''));
    // 禁止双击放大
    document.body.addEventListener('dblclick', function (event) {
      event.preventDefault();
    });

    const getFBInfo = (logined) => {
      if (logined) {
        sessionStorage.removeItem(KEY_FBSPORT)
        sessionStorage.removeItem(KEY_FBREQTIME)
      }
      const lastReq = sessionStorage.getItem(KEY_FBREQTIME)
      let diff = 99999999;
      if (lastReq) {
        // token  30分钟有效
        const diSec = dayjs().valueOf() - Number(lastReq)
        const dt = 1000 * 60
        diff = diSec / dt
      }
      // console.log(diff, 'diff-->getFBInfo-->watch--->login:', logined)
      if (diff > 29) {
        if (logined) {
          gameStore.requestFBSportUrl()
        } else {
          // console.log('requestTouristFBSportUrl:', route.path)
          if (route.path !== '/home') {
            gameStore.requestTouristFBSportUrl()
          }

        }
      }
    }
    watch(() => isLogined.value, (v) => {
      getFBInfo(v)
    }, { immediate: true, deep: true })

    onMounted(() => {
      // console.log('layout--->onmounted:isLogined', isLogined.value)
      tenantState.reqCoupletConfig()
      if (!isApp() && isIOS() && isSafari() && !window.navigator?.standalone) {
        showAddHomePopover.value = true
      }

      if (!isApp()) {
        isShowDownload.value = true
      }
    })
    onBeforeMount(() => {
      // 首页活动刷新显示
      setSession('HOME_ACTIVITY_SHOW', '1')
    })
    return {
      route,
      activeConfiguration,
      isHomePage,
      isIframe,
      isGamePage,
      opening_network,
      showFooter,
      isAgentFooter,
      agentTabBar,
      handleChange,
      beforeChange,
      tabBar,
      showAddHomePopover,
      isShowDownload,
      showTryLogin
    }
  }
}
</script>

<style lang="scss" scoped>
@import './themeName.scss';

.pop-code-wrap {
  height: 100%;
  background: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
